<template>
  <div class="contentRow">
    <div class="contentRow__main-row" :class="{'contentRow__main-row--opened': isOpen}">
      <div class="contentRow__main-row__images">
        <slot name="left-images"></slot>
      </div>
      <div class="contentRow__main-row__content"
           :class="{'contentRow__main-row--deactivated': markAsDeactivated}">
        <slot name="main"></slot>
        <slot name="main-open" v-if="isOpen"></slot>
        <slot name="main-close" v-else-if="!isOpen"></slot>
      </div>
      <div class="contentRow__main-row__actions">
        <div class="contentRow__main-row__action contentRow__main-row__action--open"
             @click="sendOpen()" v-if="!notOpenable && !isOpen"></div>
        <div class="contentRow__main-row__action contentRow__main-row__action--close"
             @click="sendClose()" v-else-if="!notOpenable && isOpen"></div>
        <div class="contentRow__main-row__action contentRow__main-row__action--select"
             v-if="select" @click="sendSelect()" :class="{ 'contentRow__main-row__action--disabled': selectDisabled }"></div>
        <div class="contentRow__main-row__action contentRow__main-row__action--edit"
             v-if="edit" @click="sendEdit()"></div>
      </div>
    </div>
    <div class="contentRow__secondary-row">
      <slot name="bottom-actions"></slot>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      edit: Boolean,
      isOpen: Boolean,
      markAsDeactivated: Boolean,
      notOpenable: Boolean,
      select: Boolean,
      selectDisabled: Boolean,
    },
    methods: {
      sendClose: function () {
        this.$emit('close')
      },
      sendEdit: function () {
        this.$emit('edit')
      },
      sendOpen: function () {
        this.$emit('open')
      },
      sendSelect: function () {
        this.$emit('select')
      },
    },
  }
</script>

<style lang="scss">
  @import "../../scss/variables";

  .contentRow {
    display: flex;
    flex-flow: column nowrap;
    margin-bottom: 5px;
    width:100%;

    &__main-row {
      border-radius: 3px;
      display: flex;
      flex-flow: row nowrap;
      overflow: hidden;
      background-color: #FFF;

      &--deactivated {
        background-color: #DDD;
      }
      &--opened {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
      }

      &__images {
        display: flex;
        flex-flow: row nowrap;
        * {
          pointer-events: none
        }
      }

      &__content {
        flex: 1;
        padding: 10px 0;
        width:100%;
      }

      &__actions {
        display: flex;
        flex-flow: row nowrap;
      }

      &__action {
        width: 40px;
        position: relative;
        cursor: pointer;

        &--close::before,
        &--edit::before,
        &--open::before,
        &--select::before {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 24px;
          height: 24px;
          pointer-events: none;
        }
        &--close {
          background-color: $suez-green;
          &::before {
            content: url("../../../static/img/arrow-down.svg");
            transform: translate(-50%, -50%) rotateZ(0.5turn);
          }
        }

        &--edit {
          background-color: $suez-grey-blue;
          &::before {
            content: url("../../../static/img/edit-icon.svg");
          }
        }

        &--open {
          background-color: $suez-green;
          &::before {
            content: url("../../../static/img/arrow-down.svg");
          }
        }

        &--select {
          background-color: $suez-green;
          &::before {
            content: url("../../../static/img/arrow-right.svg");
          }
        }

        &--disabled {
          pointer-events: none;
          opacity: 0.7;
        }
      }
    }

    &__secondary-row {
      display: flex;
      flex-flow: row nowrap;
      justify-content: flex-end;
      align-items: center;
      background-color: #F3F3F3;
      border-bottom-left-radius: 3px;
      border-bottom-right-radius: 3px;

      button {
        margin: 8px 0 8px 5px;
        &:last-of-type {
          margin-right: 8px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// ContentRow.vue?e724c0a6